// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__1LR_S","selected":"Chip_selected__spw52"};